export type ValueWithUnit = {
    value: string | number
    unit: string
    sign?: string
}

const defaultFormattingOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}

export const formatNumber = (
    value: string | number,
    formattingOptions: Intl.NumberFormatOptions = defaultFormattingOptions
) => {
    const formatter = new Intl.NumberFormat('en-US', formattingOptions)

    const formattedNumber =
        typeof value === 'number' ? formatter.format(value) : value

    return formattedNumber
}

export const formatValueWithUnit = (
    { value, unit, sign = '' }: ValueWithUnit, // Destructuring directly in parameters
    formattingOptions: Intl.NumberFormatOptions = defaultFormattingOptions
) => {
    const formattedNumber = formatNumber(value, formattingOptions)

    return unit === '$'
        ? `${sign}${unit}${formattedNumber}` // Return formatted currency
        : `${sign}${formattedNumber} ${unit}` // Return value with unit
}

export const formatNumberParts = (
    value: number,
    options: Intl.NumberFormatOptions = defaultFormattingOptions
) => {
    const formatter = new Intl.NumberFormat('en-US', options)

    const parts = formatter.formatToParts(value)

    let integer = ''
    let fraction = ''

    for (const { type, value: partValue } of parts) {
        if (type === 'fraction') {
            fraction += partValue
        } else if (type === 'decimal') {
            fraction = partValue + fraction
        } else {
            integer += partValue
        }
    }

    return { integer, fraction }
}
